import React from 'react';
import { theme } from '../../../theme';
export const ArrowRight = ({ color, size }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: theme.fontSizes[size], height: theme.fontSizes[size], viewBox: "0 0 12 11" },
        React.createElement("path", { fill: theme.colors[color], fillRule: "nonzero", d: "M5.655 10.047a1 1 0 0 0 1.415 0l4.004-4a1.005 1.005 0 0 0 .152-.195l.019-.033a.996.996 0 0 0 .037-.076l.015-.036a.993.993 0 0 0 .07-.367l-.004.09.004-.072V5.34a1.02 1.02 0 0 0-.125-.485.805.805 0 0 0-.016-.027l-.007-.012a1.002 1.002 0 0 0-.145-.183l.08.09a1.003 1.003 0 0 0-.007-.009l-.073-.08a1.021 1.021 0 0 0-.008-.01L7.069.635a1 1 0 0 0-1.413 1.415L7.95 4.34H1.363a1 1 0 0 0-.993.883l-.007.117a1 1 0 0 0 1 1h6.589L5.656 8.633a1 1 0 0 0-.084 1.32z" })));
};
ArrowRight.defaultProps = {
    color: 'black',
    size: 'x2',
};
//# sourceMappingURL=index.js.map